export const base = {
  //   breakpoints: ["768px"],
  //   space: ["0px", "2px", "4px", "8px", "16px", "32px", "64px"],
  //   fonts: {
  //     heading: "Inter, system-ui, sans-serif",
  //     body: "Inter, system-ui, sans-serif",
  //   },
  fontSizes: ["12px", "14px", "16px", "20px", "24px"],
};

export const colorsPalette = {
  primaryColor: "#DC89C1",
  darkBackground: "#031a30",
  lightWhite: "rgb(168,178,209)",
  white: "#ffffff",
  black: "#000000",
  primary: {
    300: "#A3A4FF",
    400: "#8884FF",
    500: "#6C5EFA",
    600: "#573CFA",
  },
};

export const light = {
  primary: colorsPalette.primary[600],
  bgColor: colorsPalette.white,
  sideBarColor: "#ddd",
  textColor: colorsPalette.black,
  navbarIcons: colorsPalette.primaryColor,
  placeholder: colorsPalette.black,
};

export const dark = {
  primary: colorsPalette.primary[300],
  bgColor: colorsPalette.darkBackground,
  sideBarColor: "#14213d",
  textColor: colorsPalette.white,
  navbarIcons: colorsPalette.white,
  placeholder: "#9b9b9b",

  // nav: "#f8f8f8",
  // border: "#deebf1",
  // text: "#202224",
};
